module.exports = false;


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 3